import styled from 'styled-components';
import { LoginSaveCarStyled } from '../LoginSaveCarStyled';

export const LoginSaveCarStyledDS = styled(LoginSaveCarStyled)``;
